// Load the main app module to start the app
requirejs.config({
    name: 'main',
    out: 'main-built.js',
    paths: {

        text: 'vendors/text',
        json: 'vendors/requirejs-plugins/json',
        async: 'vendors/requirejs-plugins/async',
        tpl: 'vendors/requirejs-plugins/tpl',
        css: 'vendors/require-css/css.min',
        'css-builder': 'vendors/require-css/css-builder',

        jquery: 'vendors/jquery',
        underscore: 'vendors/underscore',
        backbone: 'vendors/backbone',
        bootstrap: 'vendors/bootstrap',
        bootstrapSelect: 'vendors/bootstrap-select',
        modernizr: 'vendors/modernizr-risingsun',
        string: 'vendors/string',
        notificationFx: 'vendors/notificationFx',
        classie: 'vendors/classie',
        tether: 'vendors/tether',
        sprintf: 'vendors/sprintf',
        moment: 'vendors/moment',
        'moment-round': 'vendors/moment-round',
        momentFormats: 'prototypes/momentFormats',
        momentLocale: 'vendors/moment/locale',
        datetimePicker: 'vendors/datetime-picker',
        // richmarker: 'vendors/richmarker',
        masonry: 'vendors/masonry',
        //nlform: 'vendors/nlform',
        canvasVideo: 'vendors/canvasvideo',
        hammer: 'vendors/hammer.min',
        // taggle: 'vendors/taggle',
        jqueryfiledrop: 'vendors/jquery.filedrop',
        'iphone-inline-video': 'vendors/iphone-inline-video',
        'libphonenumber':'vendors/libphonenumber',
        objectFitPolyfill: 'vendors/objectFitPolyfill',
        IntersectionObserver: 'vendors/intersection-observer-polyfill',
        Three: 'vendors/three',
        TweenMax: 'vendors/tween-max',
        turf: 'vendors/turf-custom-build.min',//vendors/turf.min',
        Siema: 'vendors/siema',
        'js-cookie': 'vendors/js-cookie',
        sha256: 'vendors/sha256',
        Lottie: 'vendors/lottie.min',
        gsap: "vendors/gsap",
        ScrollTrigger: "vendors/ScrollTrigger",

        // App prototypes
        ObjectModel: 'prototypes/ObjectModel',
        ObjectCollection: 'prototypes/ObjectCollection',
        LocalStorage: 'prototypes/LocalStorage',
        UrlFactory: 'prototypes/UrlFactory',
        Geolocation: 'prototypes/Geolocation',
        PageView: 'prototypes/PageView',
        SubView: 'prototypes/SubView',
        ModalView: 'prototypes/ModalView',
        ApiRequest: 'prototypes/ApiRequest',
        formatPrice: 'prototypes/formatPrice',
        testEmail: 'prototypes/testEmail',
        phoneUtils: 'prototypes/phoneUtils',
        validatorNIF: 'prototypes/validatorNIF',
        MysqlDatetimeFormat: 'prototypes/MysqlDatetimeFormat',
        LazyLoad: 'prototypes/LazyLoad',
        TagCommander: 'prototypes/TagCommander',
        CSS3Events: 'prototypes/CSS3Events',
        requestAnimationFrame: 'prototypes/requestAnimationFrame',
        StringSimplification: 'prototypes/StringSimplification',
        mapboxGL: 'prototypes/mapbox-gl',
        mapbox: 'prototypes/mapbox',
        UI: 'prototypes/UI',
        formatSmsLink: 'prototypes/format-sms-link',
        challengeJs: 'prototypes/challengeJs',


        // Views
        InternalLinkView:'views/ui/InternalLinkView',
        InternalFormView:'views/ui/InternalFormView',
        BanNoticeView:'views/ui/BanNoticeView',
        BannerCategoryView:'views/blocks/BannerCategoryView',
        BottomNoticeView:'views/ui/BottomNoticeView',
        SelectView:'views/ui/SelectView',
        BtnSwitchView:'views/ui/BtnSwitchView',
        ProductBlockView:'views/blocks/ProductBlockView',
        AlertNoticeView:'views/ui/AlertNoticeView',
        ConfirmNoticeView:'views/ui/ConfirmNoticeView',
        PromptNoticeView:'views/ui/PromptNoticeView',
        InputView:'views/ui/InputView',
        InputPhoneView:'views/ui/InputPhoneView',
        AddressAutocompleteView:'views/blocks/AddressAutocompleteView',
        MessageView:'views/ui/messages/MessageView',
        BannerMessageView:'views/ui/messages/BannerMessageView',
        IndicatorMessageView:'views/ui/messages/IndicatorMessageView',
        NoticeMessageView:'views/ui/messages/NoticeMessageView',
        PaymentModeSelectionBoardView:'views/blocks/paymentModeProviders/PaymentModeSelectionBoardView',


        // Models
        PlaceModel:'models/PlaceModel',
        ErrorModel:'models/ErrorModel',

        // Widgets
        WidgetInstanceModel:'models/WidgetInstanceModel',
        WidgetInstanceView:'views/WidgetInstanceView',
        WidgetCollectionView:'views/WidgetCollectionView',

        template:'prototypes/template',

        Components:'../../../../Components',
        hooks:'prototypes/ComponentsHooks',

        // jquery shim
        jqueryShim:'prototypes/jQueryShim',

        // external
        facebook: '//connect.facebook.net/fr/sdk',
        googlePlatform: 'https://apis.google.com/js/platform',
        mapboxGLJS: 'https://api.mapbox.com/mapbox-gl-js/v2.0.1/mapbox-gl',
        mapboxJS: 'https://api.mapbox.com/mapbox.js/v3.1.1/mapbox',
        mapboxJSDirection: 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-directions/v4.1.0/mapbox-gl-directions',

    }, shim: {
        'jquery': {
            exports: '$'
        },
        "googlePlatform": {
            exports: "gapi"
        },
        'backbone': {
            deps: ['underscore', 'jquery','modernizr'], exports: 'Backbone'
        },
        'notificationFx': {
            deps: ['modernizr','classie']
        },
        'tether':{exports:'Tether'},
        //'richmarker':{},
        'bootstrap':{
            deps:['jquery','tether']
        },
        'bootstrap/collapse':{
            deps:['jquery']
        },
        'bootstrap/dropdown':{
            deps:['jquery', 'bootstrap/util']
        },
        'bootstrapSelect': {
            deps: ['tether','bootstrap/dropdown']
        },
        'moment':['underscore'],
        'momentFormats':['moment'],
        'moment-round' : ['moment'],
        'underscore': {
            exports: '_'
        },
        'facebook' : {
            exports: 'FB'
        }
    }
});

require(['entrypoint','components-list'],function(entryPoint){});
define("main-concat", function(){});

